import request from '@/utils/request_2'
import { getEnterpriseInfo} from '@/utils/index'

/** 修改医生是否展示 */
export function updateIsShow(params) {
  return request({
    url: '/system/exclusiveDoctor/updateIsShow',
    method: 'get',
    params
  })
}

/** 设置专属医生权限 */
export function setDoctorAuthority(data) {
  return request({
    url: '/system/doctorAuthority/set',
    method: 'post',
    data
  })
}

// 添加医生
export function addDoctor(data) {
  data.enterpriseId = getEnterpriseInfo('id') || 0
  return request({
    url: '/system/exclusiveDoctor/save',
    method: 'post',
    data: data
  })
}
// 修改医生
export function editDoctor(data) {
  data.enterpriseId = getEnterpriseInfo('id') || 0
  return request({
    url: '/system/exclusiveDoctor/update',
    method: 'post',
    data: data
  })
}

// 获取医生列表
// options.skipEnterpriseId：咨询管理医生列表暂时不传 enterpriseId
export function getDoctorList(data, options = {}) {
  const payload = Object.assign({}, data || {})
  if (!options.skipEnterpriseId) {
    payload.enterpriseId = payload.enterpriseId != null ? payload.enterpriseId : (getEnterpriseInfo('id') || 0)
  }
  return request({
    url: '/system/exclusiveDoctor/list',
    method: 'post',
    data: payload
  })
}

// 获取医生详情
export function getDoctorDetail(id) {
  return request({
    url: `system/exclusiveDoctor/get/${id}`,
    method: 'get'
  })
}
// 修改医生在职状态
export function changeUserStatus(id, state) {
  return request({
    url: `system/exclusiveDoctor/auditStatus`,
    method: 'post',
    data: {doctorId: id, doctorStatus: state}
  })
}
// 健康管理者可配置的门店列表",
export function healthManagerStoreConfigList(params) {
  return request({
    url: `/system/enterpriseStoreHealthManagerRelation/healthManagerStoreConfigList`,
    method: 'get',
    params
  })
}
// 门店管理 转移
export function saveOrUpdateRelation(data) {
  return request({
    url: `/system/enterpriseStoreHealthManagerRelation/saveOrUpdateRelation`,
    method: 'post',
    data
  })
}
//  配置门店列表勾选保存 
export function healthManagerStoreBatchSave(data) {
  return request({
    url: `/system/enterpriseStoreHealthManagerRelation/healthManagerStoreBatchSave`,
    method: 'post',
    data
  })
}
// 门店管理 获取门店与健康管理者关系列表
export function getRelationList(params) {
  return request({
    url: '/system/enterpriseStoreHealthManagerRelation/getRelationList',
    method: 'get',
    params
  })
}
// 设置默认健康管理师
export function setDefaultHealth(params) {
  return request({
    url: '/system/exclusiveDoctor/setDefault',
    method: 'post',
    data: params
  })
}
// 批量更新健康管理师与门店/会员/工单关联（运维端）
export function batchTransferForStore(data) {
  return request({
    url: '/system/enterpriseStoreHealthManagerRelation/batchTransferForStore',
    method: 'post',
    data
  })
}
// 筛选门店下会员（运维端）
export function memberSearch(data) {
  return request({
    url: '/system/member/search',
    method: 'post',
    data
  })
}
// 获取会员工单（运维端）
export function listProcessingByMember(data) {
  return request({
    url: '/system/workOrder/listProcessingByMember',
    method: 'post',
    data
  })
}
// 工单类型配置枚举获取
export function typeConfigList(data) {
  return request({
    url: '/system/workOrder/typeConfigList',
    method: 'get',
    params: data
  })
}